// Heat Density units with conversion factors to joule per square meter (J/m²)
export const heatDensityUnits = [
  { id: 'joule-per-square-meter', name: 'Joule per Square Meter', symbol: 'J/m²', plural: 'Joules per Square Meter', toBase: 1 },
  { id: 'joule-per-square-centimeter', name: 'Joule per Square Centimeter', symbol: 'J/cm²', plural: 'Joules per Square Centimeter', toBase: 10000 },
  { id: 'joule-per-square-millimeter', name: 'Joule per Square Millimeter', symbol: 'J/mm²', plural: 'Joules per Square Millimeter', toBase: 1000000 },
  { id: 'kilojoule-per-square-meter', name: 'Kilojoule per Square Meter', symbol: 'kJ/m²', plural: 'Kilojoules per Square Meter', toBase: 1000 },
  { id: 'calorie-per-square-centimeter', name: 'Calorie per Square Centimeter', symbol: 'cal/cm²', plural: 'Calories per Square Centimeter', toBase: 41840 },
  { id: 'kilocalorie-per-square-meter', name: 'Kilocalorie per Square Meter', symbol: 'kcal/m²', plural: 'Kilocalories per Square Meter', toBase: 4184 },
  { id: 'btu-per-square-foot', name: 'BTU per Square Foot', symbol: 'BTU/ft²', plural: 'BTUs per Square Foot', toBase: 11356.5267 },
  { id: 'btu-per-square-inch', name: 'BTU per Square Inch', symbol: 'BTU/in²', plural: 'BTUs per Square Inch', toBase: 1634339.85 },
  { id: 'watt-hour-per-square-meter', name: 'Watt Hour per Square Meter', symbol: 'Wh/m²', plural: 'Watt Hours per Square Meter', toBase: 3600 },
  { id: 'langley', name: 'Langley', symbol: 'Ly', plural: 'Langleys', toBase: 41840 },
];

export const popularHeatDensityConversions = [
  { from: 'joule-per-square-meter', to: 'kilojoule-per-square-meter' },
  { from: 'kilojoule-per-square-meter', to: 'joule-per-square-meter' },
  { from: 'btu-per-square-foot', to: 'joule-per-square-meter' },
  { from: 'joule-per-square-meter', to: 'btu-per-square-foot' },
  { from: 'calorie-per-square-centimeter', to: 'joule-per-square-meter' },
  { from: 'langley', to: 'joule-per-square-meter' },
];

export const getUnitById = (id) => heatDensityUnits.find(unit => unit.id === id);

export const convertHeatDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert heat density units and learn the conversion formula.`;
};
